import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Block from './Block';
import H2 from './H2';
import P from './P';
import Grid from './Grid';
import Cell from './Cell';
import ComparisonTable from './ComparisonTable';

const PageComparisonTable = ({ content }) => (
  <Block
    id={content.primary.internal_link_id}
    py={{ mobile: 'baseUp4', tablet: 'baseUp12' }}
  >
    <Grid>
      <Cell size={1} p="baseUnit">
        <H2 mb="baseUnit" color="coral">
          {content.primary.title1.text}
        </H2>

        <P mb="baseUnit">{content.primary.text.text}</P>
      </Cell>
      <Cell size={1} px="baseUnit">
        <ComparisonTable content={content.primary.comparison_table.document} />
      </Cell>
    </Grid>
  </Block>
);

PageComparisonTable.propTypes = {
  content: PropTypes.shape({
    primary: PropTypes.shape({
      internal_link_id: PropTypes.string,
      title1: PropTypes.shape({ text: PropTypes.string }),
      text: PropTypes.shape({ text: PropTypes.string }),
      comparison_table: PropTypes.shape({
        document: PropTypes.shape({}),
      }),
    }),
  }).isRequired,
};

export default PageComparisonTable;

export const query = graphql`
  fragment PageComparisonTableFragment on PrismicPageBodyComparisonTable {
    id
    slice_type
    primary {
      internal_link_id
      title1 {
        text
      }
      text {
        text
      }
      comparison_table {
        document {
          ...ComparisonTableFragment
        }
      }
    }
  }
`;
